import { ActionType } from "typesafe-actions";

import * as actions from "./actions";

export type AuctionAction = ActionType<typeof actions>;

export interface BaseAuctionItem {
  avgCommission: number;
  avgPrice: number;
  avgStr: number;
}

export interface AuctionItemByIata extends BaseAuctionItem {
  createdAt: string;
  iata?: string;
}

export interface AuctionItem extends BaseAuctionItem {
  iata: string;
  items?: AuctionItemByIata[];
}

export enum AuctionActionTypes {
  TABLE_FETCH_REQUEST = "@Auction/TABLE_FETCH_REQUEST",
  TABLE_FETCH_SUCCESS = "@Auction/TABLE_FETCH_SUCCESS",
  TABLE_FETCH_ERROR = "@Auction/TABLE_FETCH_ERROR",

  IATA_FETCH_SUCCESS = "@Auction/IATA_FETCH_SUCCESS",
  IATA_FETCH_REQUEST = "@Auction/IATA_FETCH_REQUEST",
  IATA_FETCH_ERROR = "@Auction/IATA_FETCH_ERROR",

  GENERATE_REPORT_REQUEST = "@Auction/GENERATE_REPORT_REQUEST",
}

export interface AuctionState {
  readonly count: number;
  readonly isLoading: boolean;
  readonly items: AuctionItem[];
  readonly itemsByIata: Record<string, AuctionItemByIata[]>;
}
